import * as React from 'react';

export interface IBusinessSignUpDropdownProps {
    id: string;
    name: string;
    label: string;
    options: IDropdownOption[];
    className?: string;
    isRequired?: boolean;
    value?: string;
    onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
}

export interface IDropdownOption {
    id: string;
    value: string;
    text: string;
}

export const BusinessSignUpDropdown: React.FC<IBusinessSignUpDropdownProps> = props => {
    const { id, name, options, className, isRequired, value, onChange } = props;

    return (
        <div className={className}>
            <select id={id} name={name} required={isRequired} value={value} onChange={onChange} className='msc-address-form__dropdown'>
                {options.map(option => (
                    <option key={option.id} value={option.value}>
                        {option.text}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default BusinessSignUpDropdown;
